import VGListener from "./src/vg";
import YandexMetrika from './src/modules/ym';

(function ($) {
	$(window).on('load', function() {
		VGListener.onLoad();
	});

	$(window).scroll(function () {
		VGListener.onScroll($(this));
	});

	$(document).ready(function () {
		VGListener.onReady();
	});

	$(window).resize(function () {
		VGListener.onResize($(this));
	});
})(jQuery);

// Modules
require ('./src/modules/social');
require('./src/modules/ym');
require('./src/modules/bg');
require('./src/modules/video');

window.vgp = require('../../../modules/index.esm');
window.ymetrika = new YandexMetrika();

require('./src/modules/catalog/catalog');
// [[vegas]]